//---- components ---------
//---- mixins -------------
//---- services -----------
import DSService from '@/app/services/ds.service.js';
//---- other --------------
//---- 3rd-parties --------

export default {

    data() {
        return {
            selectedWorkgroup: null,
        }
    },

    computed: {
        dsDashboard() {
            return this.$store?.state?.dsDashboard;
        },
        pageSize() {
            return this.dsDashboard?.pageSize;
        },
        tabs() {
            return this.dsDashboard?.dashboardTabs;
        },
        page() {
            return this.dsDashboard?.page;
        },
        serviceSessionsData() {
            return this.dsDashboard?.serviceSessionsData;
        },
        currentlySelectedDetailsTab() {
            return this.dsDashboard?.dsDetailActiveTab;
        },
        dsDashboardInitData() {
            return this.dsDashboard?.dsDashboardInitData;
        },
        filterName() {
            return this.dsDashboard?.filterName;
        },
        filterValue() {
            return this.dsDashboard?.filterValue;
        },
        sortBy() {
            return this.dsDashboard?.sortBy;
        },
        sortDesc() {
            return this.dsDashboard?.sortDesc;
        },
    }, // end computed

    methods: {
        // clear the tabs
        clearTabs() {
            this.$store.dispatch("dsDashboard/clearDsDashboardTabs");
        },

        // clear the sessions data
        clearSessionsData() {
            this.$store.dispatch("dsDashboard/clearServiceSessionsData");
        },

        // clear the DsDashboardInit data
        clearDsDashboardInitData() {
            this.$store.dispatch("dsDashboard/clearDsDashboardInitData");
        },

        // clear the opened ds from tab
        clearOpenedDSFromTab() {
            this.$store.dispatch("dsDashboard/setOpenedDSFromTab", null);
        },

        // set the current active DS tab
        // @currentTab: active DS Tab
        setCurrentActiveDSTab(currentTab) {
            this.$store.dispatch("dsDashboard/setCurrentActiveDSTab", currentTab);
        },

        // add the new tab to DS dashbaord
        // @tabDetails: new tab object
        addDashBoardTab(tabDetails) {
            this.$store.dispatch("dsDashboard/addDsDashboardTab", tabDetails);
        },

        // remove the tab from DS dashboard
        // @tabDetails: active tabDetails
        async removeDashboardTab(tabDetails) {
            await this.$store.dispatch("dsDashboard/removeDsDashboardTab", tabDetails);
            if (this.tabs.size == 1)
                this.setCurrentActiveDSTab("Default")
        },

        // set the current active DS Detail tab
        // @currentTab: active DS Deatil content Tab
        setCurrentActiveDSDetailTab(currentTab) {
            this.$store.dispatch("dsDashboard/setCurrentActiveDSDetailTab", currentTab);
        },

        // set the opened ds from tab
        // @tabInfo: dashboard sessions tab 
        setOpenedDSFromTab(tabInfo) {
            this.$store.dispatch("dsDashboard/setOpenedDSFromTab", tabInfo);
        },

        // set the current page
        // @page: current page
        setCurrentPage(page) {
            this.$store.dispatch("dsDashboard/setCurrentPage", page);
        },

        // set default page i.e page = 1
        setDefaultPage() {
            this.$store.dispatch("dsDashboard/setCurrentPage", 1);
        },

        // set the current template view
        // @templateView: current view (either dashboard or repair-history)
        setCurrentTemplateView(templateView) {
            this.$store.dispatch("dsDashboard/setCurrentTemplateView", templateView);
            return;
        },

        // set the current filterName
        // @filterName: current filterName
        setFilterName(filterName) {
            this.$store.dispatch("dsDashboard/setFilterName", filterName);
            this.pushWithAnchor({ hash: this.updateHash("filterName") });
        },

        // clear the search filter name
        clearSearchFilterName() {
            this.$store.dispatch("dsDashboard/setFilterName", null);
        },

        // set the current filterValue
        // @filterValue : current filterValue
        setFilterValue(filterValue) {
            this.$store.dispatch("dsDashboard/setFilterValue", filterValue);
            this.pushWithAnchor({ hash: this.updateHash("filterValue") });
        },

        // clear the search filter value
        clearSearchFilterValue() {
            this.$store.dispatch("dsDashboard/setFilterValue", "");
        },

        // set the sortBy
        // @sortBy : column name
        setSortBy(sortBy) {
            this.$store.dispatch("dsDashboard/setSortBy", sortBy);
            this.pushWithAnchor({ hash: this.updateHash("sortBy") });
        },

        // set the sortDesc
        // @sortDesc : asc or desc
        setSortDesc(sortDesc) {
            this.$store.dispatch("dsDashboard/setSortDesc", sortDesc);
            this.pushWithAnchor({ hash: this.updateHash("sortDesc") });
        },

        // clear sort filter
        clearSortfilter() {
            this.$store.dispatch("dsDashboard/clearSortfilter");
        },

        // get the dashboard init info
        getDSDashboardInit() {
            this.setCurrentActiveDSTab("Default");
            this.$store.dispatch("dsDashboard/getDSDashboard").then(() => {
                this.pushWithAnchor({ path: "/ds/dashboard", hash: this.updateHash("oDS") });
            });
        },

        // get repair history init data
        getDSRepairHistoryInit() {
            this.setCurrentActiveDSTab("Default");
            this.$store.dispatch("dsDashboard/getDSRepairHistoryInit").then(() => {
                this.pushWithAnchor({ path: "/ds/repair-history", hash: this.updateHash("oDS") });
            });
        },

        // load DSTemplate With Sessions data
        // @currentTemplateView : current view dashboard or repair history
        // @currentDashboardActiveTab : sessions or workgroup tab
        // @page : current page
        loadDSTemplateWithSessions(currentTemplateView, currentDashboardActiveTab, page) {
            // check if currentTemplateView is REPAIR HISTORY
            if (currentTemplateView == "DS_REPAIR_HISTORY") {
                return this.$store
                    .dispatch("dsDashboard/getDSRepairHistoryInit").then(() => {
                        this.pushWithAnchor({ hash: this.updateHash("RepairHistory") });
                        this.$store.getters["projectData/currentQuest"].name = "SERVICE_SESSIONS";
                        this.getRepairHistorySessionsData(page);
                        return Promise.resolve();
                    });
            }

            // in all other cases, use DS_DASHBOARD
            return this.$store.dispatch("dsDashboard/getDSDashboard").then(() => {
                this.$store.getters["projectData/currentQuest"].name = "SERVICE_SESSIONS";
                // check if current dashboard tab is "WRKGRP"
                if (currentDashboardActiveTab == "WRKGRP")
                    // load the sessions data by workgroups
                    this.getSessionsDataByWorkgroup(page);
                // load the sessions data by users
                else this.openDsDashboardPage(page);
                return Promise.resolve();
            });

        }, // end loadDSTemplateWithSessions()

        // get the ds sessions list 
        //@currentPage : current page number
        //below parameters is using for previous and next buttons result in case of need to load 
        //sessions data from backend for next page 
        //@loadDSDetail : if true then load ds details with sessions data
        //@isFirst : if true it means load ds details of first row of sessions data
        //           else load ds details of last row of sessions data
        async updateServiceSessionData(currentPage, loadDSDetail, isFirst) {

            let currentWorklistTabIndex = this.currentWorklistTabIndex;
            // if this.currentWorklistTabIndex is not defined, default to 0
            if (!currentWorklistTabIndex)
                currentWorklistTabIndex = 0;

            this.setCurrentPage(currentPage);
            this.setOpenedDSFromTab(currentWorklistTabIndex == 0 ? "SESSION" : "WRKGRP");
            const reqParams = new FormData();
            reqParams.append("page", currentPage);
            reqParams.append("rows", this.pageSize);
            reqParams.append("filtername", this.filterName == null ? "DS" : this.filterName);
            reqParams.append("filtervalue", this.filterValue);
            reqParams.append("sidx", this.sortBy);
            reqParams.append("sort", this.sortDesc);

            if (currentWorklistTabIndex == 1) {
                if (this.selectedWorkgroup == undefined) {
                    if (this.dsDashboardInitData.hasAllWorkgroups == "true")
                        reqParams.append("workgroup", "ALL");
                    else reqParams.append("workgroup", "ALL_WORKGROUP");
                } else
                    reqParams.append("workgroup", this.selectedWorkgroup);
            }
                
            let res = await this.$store.dispatch("dsDashboard/getSessionsData", reqParams);
            this.pushWithAnchor({ hash: this.updateHash("oDS") });
            if (!loadDSDetail) 
                return res;
            
             if (isFirst)
                await this.getDSDetails(res.data.rows[0].cell[0], true)
             else
                await this.getDSDetails(res.data.rows[this.pageSize - 1].cell[0], true)
            
            return res;
        }, // end updateServiceSessionData

        // update and open the dsDashboardPage
        openDsDashboardPage(currentPage, loadDSDetail, isFirst) {
            this.updateServiceSessionData(currentPage, loadDSDetail, isFirst)
                .then(() => this.pushWithAnchor({ hash: this.updateHash("oDS") }))
        },

        // get the sessions data by workgroup and page
        // @currentPage : current page number
        getSessionsDataByWorkgroup(currentPage) {
            this.setCurrentPage(currentPage);
            this.setOpenedDSFromTab("WRKGRP");
            const reqParams = new FormData();
            reqParams.append("page", currentPage);
            reqParams.append("rows", this.pageSize);
            reqParams.append("filtername", this.filterName == null ? "DS" : this.filterName);
            reqParams.append("filtervalue", this.filterValue);
            reqParams.append("sidx", this.sortBy);
            reqParams.append("sort", this.sortDesc);
            if (this.selectedWorkgroup == undefined) {
                if (this.dsDashboardInitData.hasAllWorkgroups == "true")
                    reqParams.append("workgroup", "ALL");
                else reqParams.append("workgroup", "ALL_WORKGROUP");
            } else
                reqParams.append("workgroup", this.selectedWorkgroup);

            DSService.DSDashboardService.getSessionsDataByWorkgroup(reqParams).then(() => {
                this.pushWithAnchor({ hash: this.updateHash("oDS") });
            })
        },

        // get sessions data by repair hisory
        // @currentPage : current page number
        //
        // below parameters are used for previous and next buttons result in case of need to load 
        // sessions data from backend for next page 
        // @loadDSDetail : if true then load ds details with sessions data
        // @isFirst : if true it means load ds details of first row of sessions data
        //           else load ds details of last row of sessions data
        getRepairHistorySessionsData(currentPage, loadDSDetail, isFirst) {
            this.setCurrentPage(currentPage);
            this.clearOpenedDSFromTab();
            const reqParams = new FormData();
            reqParams.append("action", "search");
            reqParams.append("filtername", "SERIAL_NUMBER");
            reqParams.append("filtervalue", this.filterValue);
            reqParams.append("_search", false);
            reqParams.append("page", currentPage);
            reqParams.append("rows", this.pageSize);
            reqParams.append("sidx", this.sortBy);
            reqParams.append("sort", this.sortDesc);
            this.$store.dispatch("dsDashboard/getRepairHistorySessionsData", reqParams).then((res) => {
                if (loadDSDetail) {
                    if (isFirst)
                        this.getDSDetails(res.data.rows[0].cell[0], true)
                    else
                        this.getDSDetails(res.data.rows[this.pageSize - 1].cell[0], true)

                }
                this.pushWithAnchor({ hash: this.updateHash("oDS") });
            })
        },

        // load ds-detail from server and navigate to the ds-details page 
        // if we're not already on it
        // @DSID: Session ID
        // @createTab: add tab if true
        // @isNotSelectedDS: if true, don't set as active tab and don't  
        //                   open ds details page 
        getDSDetails(DSID, createTab, isNotSelectedDS) {
            const reqData = new FormData();
            reqData.append("action", "view");
            reqData.append("DSID", DSID);
            return this.$store.dispatch("dsDashboard/getDSDetails", reqData).then((res) => {
                if (createTab)
                    this.addDashBoardTab({
                        tabTitle: res.data.title,
                        tabId: res.data.DSID
                    });

                if (isNotSelectedDS)
                    return res;

                this.setCurrentActiveDSTab(res.data.DSID)
                this.setCurrentActiveDSDetailTab(null);
                this.pushWithAnchor({ path: "/ds/details", hash: this.updateHash("sDS") })

                return res;
            });

        },

        // get the ds details page tab data by tabType
        // @DSID : session ID
        // @tabType : tab action type
        getDSDetailsTabsContent(DSID, tabType) {
            const reqData = new FormData();
            reqData.append("action", tabType);
            reqData.append("DSID", DSID);
            this.setCurrentActiveDSDetailTab(tabType);
            return this.$store.dispatch("dsDashboard/getDSDetailsTabsContent", reqData).then(() => {
                this.pushWithAnchor({ hash: this.updateHash("tab") });
            })
        },

        // push to route with anchor (hash (URI fragment)) if needed 
        pushWithAnchor(to) {
            const fromPath = this.$route.path
            const fromHash = this.$route.hash
            // console.trace(fromPath+fromHash+' --> '+to.path+'#'+to.hash)
            if (to.path && to.path != fromPath) {
                // console.log("fromPath= "+fromPath+"  toPath: "+to.path+"#"+to.hash)
                this.safeRouterPush({ path: to.path, hash: to.hash })
                return;
            }
            if (to.hash && '#' + to.hash !== fromHash) {
                // console.log("fromHash= " + fromHash + "  toHash: #" + to.hash)
                if (to.path)
                    this.safeRouterPush({ path: to.path, hash: to.hash })
                else
                    this.safeRouterPush({ hash: to.hash })
                return;
            }
        },

        // update the current hash using the vuex state and the passed destination type
        updateHash(type) {
            // console.log("updateHash")
            // get the current hash 
            var currentHash = this.$route.hash;
            // get the hash values of current hash url in form of map i.e key value pair
            var hashValues = this.parseHash(currentHash);
            // check if request for RepairHistory template view
            if (type.includes("RepairHistory")) {
                //clear the hash values
                hashValues.clear();
                //set the current view type
                hashValues.set("view", "RepairHistory")
                return this.formatHash(hashValues);
            }
            // check if request for DASHBOARD template view
            if (type.includes("DASHBOARD")) {
                //clear the hash values
                hashValues.clear();
                hashValues.delete("view")
                // check if dashboard tab exist
                if (this.dsDashboard?.openedDSFromTab != null)
                    hashValues.set("dashTab", this.dsDashboard?.openedDSFromTab)
                return this.formatHash(hashValues);
            }
            // check if no opened ds ids exist
            if (this.tabs.size == 0) {
                // delete the opened ds ids from hash values map if exist
                hashValues.delete("oDS");
                // delete the selected ds id from hash values map if exist
                hashValues.delete("sDS");
                // delete the selected ds detail tab from hash values map if exist
                hashValues.delete("tab");
            }
            // check current page is not first page
            if (this.page >= 1)
                hashValues.set("page", this.page)
            // check sortBy exist
            if (this.sortBy != "")
                hashValues.set("sortBy", this.sortBy)
            // check sortDesc exist
            if (this.sortDesc != "")
                hashValues.set("sortDesc", this.sortDesc)
            // check if dashboard tab exist
            if (this.dsDashboard?.openedDSFromTab != null)
                hashValues.set("dashTab", this.dsDashboard?.openedDSFromTab)
            // check if request for search filter
            if (type.includes("filterName")) {
                if (this.filterName != null)
                    hashValues.set("filterName", this.filterName)
                else
                    hashValues.delete("filterName")
            }
            // check if request for search input
            if (type.includes("filterValue"))
                hashValues.set("filterValue", this.filterValue)

            // check if request for opened DS
            if (type.includes("oDS") && this.getHashForOpenedDSIds() != "") {
                // delete the selected ds id from hash values map if exist
                hashValues.delete("sDS");
                // delete the selected ds detail tab from hash values map if exist
                hashValues.delete("tab");
                // put the opened DS ids in hash values map
                hashValues.set("oDS", this.getHashForOpenedDSIds())
            }
            // check if request for selected DS
            if (type.includes("sDS") && this.getHashForOpenedDSIds() != "") {
                // delete the selected ds detail tab from hash values map if exist
                hashValues.delete("tab");
                // put the opened DS ids in hash values map
                hashValues.set("oDS", this.getHashForOpenedDSIds());
                // put the Active DS tab id in hash values map
                hashValues.set("sDS", this.dsDashboard?.dsActiveTab)
            }
            // check if request for ds detail tab
            if (type.includes("tab"))
                hashValues.set("tab", this.dsDashboard?.dsDetailActiveTab)

            return this.formatHash(hashValues);
        }, // end updateHash

        //---------------------------------------------------------------------------------

        // convert the specified hashString (URI fragment) into a map with key-value pairs
        parseHash(hashString) {
            var hashValues = new Map();
            if (hashString == "")
                return hashValues;
            // get the part after the hash and split it on key-value separator (&)
            var hashURLDatas = hashString.split('#')[1].split("&");
            // iterate over the key-value pairs and split the key from value
            for (var i = 0; i < hashURLDatas.length; i++) {
                var hashItem = hashURLDatas[i].split("=");
                // add in the map
                hashValues.set(hashItem[0], hashItem[1]);
            }
            return hashValues;
        }, // end parseHash

        // convert the map into a hash (URI fragment) string
        formatHash(hashValues) {
            var currentHash = ""
            // iterate the hashValues by keys
            for (var key of hashValues.keys()) {
                if (currentHash == "")
                    currentHash = key + "=" + hashValues.get(key)
                else
                    currentHash = currentHash + "&" + key + "=" + hashValues.get(key)
            }
            return currentHash;
        }, // end formatHash

        //---------------------------------------------------------------------------------

        // get the hash values for opened DS Ids
        getHashForOpenedDSIds() {
            var hash = "";
            if (this.tabs.size > 1) {
                var index = 0;
                // iterate the opened tab
                for (let tab of Array.from(this.tabs).splice(1)) {
                    if (index == 0) hash = hash + tab[0];
                    else hash = hash + "@" + tab[0];
                    index++;
                }
            }
            return hash;
        }, // end getHashForOpenedDSIds

        // load the ds sessions according to current hash
        loadDSSessionsByHashURL(hashURLDatas) {
            // check if hash url datas contains dashtab key
            if (hashURLDatas.has("dashTab"))
                //set the current dashboard tab
                this.setOpenedDSFromTab(hashURLDatas.get("dashTab"));
            // check if hash url datas contains page key
            if (hashURLDatas.has("page"))
                // set the current page number
                this.setCurrentPage(hashURLDatas.get("page"));
            // check if hash url datas contains sortBy key
            if (hashURLDatas.has("sortBy"))
                // set the sortBy filter
                this.setSortBy(hashURLDatas.get("sortBy"));
            // check if hash url datas contains sortDesc key
            if (hashURLDatas.has("sortDesc"))
                // set the sortDesc filter
                this.setSortDesc(hashURLDatas.get("sortDesc"));
            // check if hash url datas contains search filterName key
            if (hashURLDatas.has("filterName"))
                // set the current search filter name
                this.setFilterName(hashURLDatas.get("filterName"));
            // check if hash url datas contains search filterValue key
            if (hashURLDatas.has("filterValue"))
                // set the search input text
                this.setFilterValue(hashURLDatas.get("filterValue"));
            // check if currentTemplateView is DASHBOARD
            if (this.dsDashboard?.templateView == "DS_DASHBOARD") {
                // check if current dashboard tab is "WRKGRP"
                if (this.dsDashboard?.openedDSFromTab == "WRKGRP")
                    // load the sessions data by workgroups
                    return this.getSessionsDataByWorkgroup(this.page);
                else
                    // load the sessions data by users
                    return this.updateServiceSessionData(this.page);
            }
            // check if currentTemplateView is REPAIR HISTORY
            if (this.dsDashboard?.templateView == "DS_REPAIR_HISTORY") {
                if (!((hashURLDatas.has("view") && hashURLDatas.get("view")) == "RepairHistory"))
                    this.updateServiceSessionData(this.page);
                else
                    this.getRepairHistorySessionsData(this.page);
            }
        }, // end loadDSSessionsByHashURL

        // load the ds deatils according to current hash
        loadDSDetailsByHashURL(hashURLDatas) {
            // clear the hash url
            this.pushWithAnchor({ hash: "" });
            let hashValues = {};
            // check opened DS exist
            if (hashURLDatas.has("oDS"))
                // get all the openedDS info
                hashValues.openedDSinfo = hashURLDatas.get("oDS").split("@");
            // check active DS exist 
            if (hashURLDatas.has("sDS"))
                //get the active ds id
                hashValues.selectedDS = hashURLDatas.get("sDS");
            // check active ds detail tab exist 
            if (hashURLDatas.has("tab"))
                //get the active ds detail tab info
                hashValues.activeTabDSinfo = hashURLDatas.get("tab");
            // open sequentially
            const openTabsSequentially = (tabsToOpen) => {
                if (tabsToOpen.length == 0)
                    return;
                return this.getDSDetails(tabsToOpen[0], true, true).then(() => {
                    if (tabsToOpen.length == 1) {
                        if (hashValues.selectedDS) {
                            this.getDSDetails(hashValues.selectedDS).then(() => {
                                if (hashValues.activeTabDSinfo)
                                    this.getDSDetailsTabsContent(hashValues.selectedDS, hashValues.activeTabDSinfo);
                            })
                        }
                        else
                            this.pushWithAnchor({ hash: this.updateHash("oDS") });
                    }
                    else
                        openTabsSequentially(tabsToOpen.splice(1, tabsToOpen.length))
                });
            }
            openTabsSequentially(hashValues.openedDSinfo)
        } // end loadDSDetailsByHashURL

    } // end methods
}